import { Work_Type } from "../../../../../../generated/graphql";
import StyleInput from "../../../../../../components/inputs/style-input";
import RadioContainer from "../../../../../../components/shared/radio_container/radio_container";
import { Fragment } from "react";

export const WORK_TYPE_RADIO_OPTIONS = [
  { value: Work_Type.WorkTypeManagementPolicy, label: "근무유형 관리정책" },
  { value: Work_Type.SFCommutingPolicy, label: "표준 / 시차 출퇴근" },
  { value: Work_Type.FlexibleWorkingHoursPolicy, label: "탄력 근무 시간제" },
  { value: Work_Type.FlexibleSchedulePolicy, label: "선택 근무 시간제" },
  { value: Work_Type.AutonomousCommutingPolicy, label: "자율출근제" }
] as const;

interface WorkTypeRadioGroupProps {
  workType: Work_Type;
  handleWorkType: (payload: Work_Type) => void;
}

export function WorkTypeRadioGroup({
  workType,
  handleWorkType
}: WorkTypeRadioGroupProps) {
  return (
    <RadioContainer>
      {WORK_TYPE_RADIO_OPTIONS.map(option => (
        <Fragment key={option.value}>
          <StyleInput
            type="radio"
            id={option.value}
            minWidth="15px"
            maxWidth="15px"
            name="workType"
            value={option.value}
            checked={workType === option.value}
            onChange={event => {
              handleWorkType(event.currentTarget.value as Work_Type);
            }}
          />
          <label htmlFor={option.value}>{option.label}</label>
        </Fragment>
      ))}
    </RadioContainer>
  );
}
